/**
 * Rows to CSV, for exporting a supplied sample before retention removes it.
 *
 * Columns are the union of every row's keys, in first-seen order, so a field
 * present on only some rows still gets a column. Nested values (feature maps,
 * KYC profiles) are written as JSON in one cell — the same shape the loader
 * accepts back, so an export can be resubmitted as it is.
 */
export function toCsv(rows: Record<string, unknown>[]): string {
    const columns: string[] = [];
    const seen = new Set<string>();
    for (const row of rows) {
        for (const key of Object.keys(row)) {
            if (!seen.has(key)) {
                seen.add(key);
                columns.push(key);
            }
        }
    }
    const lines = [columns.map(cell).join(',')];
    for (const row of rows) lines.push(columns.map((c) => cell(row[c])).join(','));
    return lines.join('\r\n');
}

function cell(value: unknown): string {
    if (value === null || value === undefined) return '';
    const text = typeof value === 'object' ? JSON.stringify(value) : String(value);
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Hands the browser a text file to save. */
export function downloadText(filename: string, text: string, type = 'text/csv;charset=utf-8') {
    const url = URL.createObjectURL(new Blob([text], { type }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
